// Resolves the backend base URL. Normally just REACT_APP_BACKEND_URL (baked in at build time).
//
// But when this app is opened through a forwarded/tunneled URL (VS Code "Ports" tab, GitHub
// Codespaces, devtunnels, etc — e.g. testing on a phone) while REACT_APP_BACKEND_URL still says
// "http://localhost:8000", that literally means "the phone itself" and every API call silently
// fails ("Something went wrong. Please refresh."). In that specific situation, derive the
// backend's forwarded URL from the current page's own forwarded hostname instead.
function resolveApiBase() {
  const configured = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") return configured;

  const host = window.location.hostname;
  const isLocalHost = host === "localhost" || host === "127.0.0.1";
  const configuredIsLocal = !!configured && /localhost|127\.0\.0\.1/.test(configured);

  if (isLocalHost || !configuredIsLocal) return configured;

  // Forwarded hostnames from tools like VS Code Ports / Codespaces / devtunnels commonly embed
  // the port in the subdomain (e.g. abc123-3000.region.devtunnels.ms) — swap 3000 for 8000.
  if (host.includes("-3000")) {
    return `${window.location.protocol}//${host.replace("-3000", "-8000")}`;
  }
  // Plain LAN/IP access (e.g. http://192.168.1.20:3000) — same host, backend port instead.
  return `${window.location.protocol}//${host}:8000`;
}

export const API_BASE_URL = resolveApiBase();
